const initState = {
  showConfirmModal: false,
};

export const confirmModalReducer = (state = initState, action) => {
  switch (action.type) {
    case "SHOW_CONFIRM_MODAL":
      return {
        ...state,
        showConfirmModal: true,
      };
    case "CLOSE_CONFIRM_MODAL":
      return {
        ...state,
        showConfirmModal: false,
      };
    default:
      return state;
  }
};
